<script>
import Fetch from '@ohmsd/v-fetch';

export default Fetch;
</script>
